export default {
	MAINTENANCE_EXTRAS: 'companies/:company_id/maintenance-extras/'
}
